var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('p',{staticStyle:{"font-size":"24px"}},[_vm._v("页面找不到了!!!"),_c('span',{staticStyle:{"color":"#47cb89","font-size":"24px","margin":"0 10px"}},[_vm._v(_vm._s(_vm.countDown))]),_vm._v("秒后，页面将跳转到登录界面！！！")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-403b7d2b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/Error.vue
// module id = null
// module chunks = 